import "./component-library182.mjs";
import normalizeComponent from "./component-library91.mjs";
const _sfc_main = {
  name: "DeliveryAvailabilityMail",
  props: {
    success: { type: Boolean },
    content: {
      type: Object,
      default: () => ({
        success: {
          title: "Vielen Dank!",
          copy: "Du erhälst in Kürze eine E-Mail von uns, um deine Anfrage zu bestätigen."
        },
        // eslint-disable-next-line max-len
        copy: "Gib bitte deine E-Mail-Adresse ein, damit wir dich informieren können, sobald das Produkt wieder verfügbar ist."
      })
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return !_vm.success ? _c("div", { staticClass: "delivery-availability-mail" }, [_vm._t("content", function() {
    return [_c("p", { staticClass: "delivery-availability-mail__description", domProps: { "innerHTML": _vm._s(_vm.content.copy) } })];
  }), _vm._t("default")], 2) : _c("div", { staticClass: "delivery-availability-mail--success" }, [_vm._t("success", function() {
    return [_c("p", { domProps: { "innerHTML": _vm._s(_vm.content.success.title) } }), _c("p", { domProps: { "innerHTML": _vm._s(_vm.content.success.copy) } })];
  })], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "0bde8831",
  null,
  null
);
const deliveryAvailabilityMail = __component__.exports;
export {
  deliveryAvailabilityMail as default
};
